
<button class="btn btn-primary btn-circle-sm oi oi-question-mark" (click)="showDialog()"></button>